/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Settings_Apikeys_Delete_DescriptionInputs */

const en_settings_apikeys_delete_description = /** @type {(inputs: Settings_Apikeys_Delete_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete ${i?.name}? This action cannot be undone.`)
};

const zh_settings_apikeys_delete_description = /** @type {(inputs: Settings_Apikeys_Delete_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`确定要删除 ${i?.name} 吗？此操作无法撤销。`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete {name}? This action cannot be undone." |
*
* @param {Settings_Apikeys_Delete_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_delete_description = /** @type {((inputs: Settings_Apikeys_Delete_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Delete_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_delete_description(inputs)
	return zh_settings_apikeys_delete_description(inputs)
});
export { settings_apikeys_delete_description as "settings.apikeys.delete_description" }